import { render } from "./list-ticket.vue?vue&type=template&id=45835b0a&scoped=true"
import script from "./list-ticket.vue?vue&type=script&lang=js"
export * from "./list-ticket.vue?vue&type=script&lang=js"

import "./list-ticket.vue?vue&type=style&index=0&id=45835b0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45835b0a"]])

export default __exports__